import Entity from "@/services/westore/entities/entity";

class UsersControl extends Entity {
  static uri = "/users";
  static statuses = {
    Active: 1,
    Inactive: 2,
  };

  static store(payloadRequest) {
    return super.create(UsersControl.uri, payloadRequest);
  }

  static getOne(id, params = {}) {
    return super.get(UsersControl.uri, id, params);
  }

  static getAll(params = {}) {
    return super.getAll(UsersControl.uri, params);
  }

  static updateData(params = {}, id) {
    let uri = `${UsersControl.uri}/${id}`;
    return super.patch({ uri, payload: params });
  }
}

export default UsersControl;
